import { SelectFilled } from "~/ui/infra/SelectFilled";
import { useTranslation } from "react-i18next";
import { useCallback, useMemo, useRef } from "react";
import { useFetcher } from "@remix-run/react";

export function LanguageSelect() {
  const { i18n } = useTranslation();
  const formRef = useRef<HTMLFormElement>(null);
  const languages = useMemo(() => {
    if (Array.isArray(i18n.options.supportedLngs)) {
      return i18n.options.supportedLngs.filter((lng) => lng !== "cimode").map((lng) => ({ label: lng.toUpperCase(), value: lng }));
    } else {
      return [];
    }
  }, [i18n.options.supportedLngs]);
  const fetcher = useFetcher();

  const submitForm = useCallback<({ value }: { value: string }) => void>(
    async ({ value }) => {
      fetcher.submit(formRef.current, { method: "post" });
      await i18n.changeLanguage(value);
    },
    [fetcher, i18n]
  );

  return (
    <fetcher.Form method="post" action="/api/settings" ref={formRef} reloadDocument replace>
      <SelectFilled
        name="language"
        optionTemplate={OptionTemplate}
        defaultValue={languages.find((lng) => lng.value === i18n.language)}
        options={languages.filter((lng) => lng.value !== i18n.language)}
        onChange={submitForm}
      />
    </fetcher.Form>
  );
}

function OptionTemplate(item: { label: string; value: string }, isSelected: boolean) {
  return !isSelected && <span className="max-w-[250px] truncate">{item.label}</span>;
}
